import React, { useState } from 'react';

const steps = [
  { id: 1, title: "Step 1: Create a Sense of Urgency", action: "Communicate honestly why the status quo is no longer viable.", overcomes: "Complacency and Denial" },
  { id: 2, title: "Step 2: Build a Guiding Coalition", action: "Assemble a powerful, cross-functional group of leaders.", overcomes: "Mistrust and Resistance" },
  { id: 3, title: "Step 3: Form a Strategic Vision", action: "Create a clear, compelling vision of the future.", overcomes: "Fear of the Unknown" },
  { id: 4, title: "Step 4: Enlist a Volunteer Army", action: "Communicate the vision frequently using emotional language.", overcomes: "Lack of Understanding" },
  { id: 5, title: "Step 5: Enable Action", action: "Identify and remove obstacles like outdated processes.", overcomes: "Fear of Failure" },
  { id: 6, title: "Step 6: Generate Short-Term Wins", action: "Plan for and celebrate visible successes early.", overcomes: "Loss Aversion" },
  { id: 7, title: "Step 7: Sustain Acceleration", action: "Use credibility from wins to tackle harder issues.", overcomes: "Change Fatigue" },
  { id: 8, title: "Step 8: Institute Change", action: "Anchor new behaviors in the organizational culture.", overcomes: "Cultural Inertia" },
];

export default function KotterAccordion() {
  const [openStep, setOpenStep] = useState(null);

  return (
    <section className="mb-10 font-sans">
      <h2 className="text-3xl font-bold text-gray-800 mb-6 border-b-2 border-red-600 pb-2">🚀 Kotter's 8-Step Process</h2>
      <div className="space-y-3">
        {steps.map((step) => (
          <div key={step.id} className="rounded-lg shadow-md overflow-hidden bg-white border border-gray-100">
            <button 
              onClick={() => setOpenStep(openStep === step.id ? null : step.id)}
              className="w-full flex justify-between items-center p-4 bg-red-50 hover:bg-red-100 transition-colors"
            >
              <span className="text-lg font-semibold text-red-900">{step.title}</span>
              <span className={`text-red-600 transition-transform duration-300 ${openStep === step.id ? 'rotate-180' : ''}`}>▼</span>
            </button>
            <div className={`transition-all duration-300 ease-in-out overflow-hidden ${openStep === step.id ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'}`}>
              <div className="p-4 text-gray-700 bg-white border-t border-red-100">
                <p><strong className="text-red-600">Action:</strong> {step.action}</p>
                <p className="mt-2"><strong className="text-red-600">Overcomes:</strong> {step.overcomes}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}